// Hardcoded recipe tags. Labels live in the web app's translation files
// (key `tags.<slug>`); add a slug here and a label in each locale to add a tag.
export const TAGS = ['breakfast', 'brunch', 'lunch', 'dinner', 'vegetarian', 'vegan', 'gluten-free'] as const;

export type TagSlug = (typeof TAGS)[number];

export function isTagSlug(value: unknown): value is TagSlug {
  return typeof value === 'string' && (TAGS as readonly string[]).includes(value);
}
